module.exports = __webpack_public_path__ + "static/media/need-diabetes.a8312231.jpg";